import React, { type MouseEvent, type ReactNode } from 'react';
import { styled } from '@compiled/react';
import noop from 'lodash/noop';
import type { UIAnalyticsEvent } from '@atlaskit/analytics-next';
import AkButton from '@atlaskit/button';
import { token } from '@atlaskit/tokens';
import { useIntl } from '@atlassian/jira-intl';
import messages from './messages';

type Props = {
	onClick: (event: MouseEvent<HTMLElement>, analyticsEvent: UIAnalyticsEvent) => void;
	label?: ReactNode | string;
};

const ClearFilterButton = (props: Props) => {
	const { formatMessage } = useIntl();
	return (
		<StyledClearFilterButton
			data-test-id="filters.ui.filters.clear-button.ak-button"
			data-testid="filters.ui.filters.clear-button.ak-button"
		>
			<AkButton appearance="subtle" onClick={props.onClick}>
				{props.label || formatMessage(messages.label)}
			</AkButton>
		</StyledClearFilterButton>
	);
};

ClearFilterButton.defaultProps = {
	onClick: noop,
};

export default ClearFilterButton;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const StyledClearFilterButton = styled.div({
	paddingLeft: token('space.050', '4px'),
	paddingRight: token('space.050', '4px'),
});
